<script setup lang="ts">
import { defineComponent, type Component } from 'vue'

defineOptions({ name: 'OrgaElementHoverTrigger' })

const SlotPassthrough = defineComponent({
  name: 'OrgaElementHoverTriggerPassthrough',
  inheritAttrs: false,
  setup(_props, { slots }) {
    return () => slots.default?.()
  },
})

const props = defineProps<{
  enabled: boolean
  hoverCard: Component
  label?: string
  libLong?: string | null
  desc?: string | null
}>()

const resolvedCard = computed(() => (props.enabled ? props.hoverCard : SlotPassthrough))
</script>

<template>
  <component
    :is="resolvedCard"
    :label="label"
    :lib-long="libLong"
    :desc="desc"
  >
    <slot />
  </component>
</template>
